/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/restrictions/modal-general-settings/modal-general-settings.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '../../../../../../public/upgrade/root/ga/ga.service';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/constants';
import * as import9 from '@angular/core/src/linker/component_factory';
import * as import10 from '@angular/router/src/router_state';
import * as import11 from '../../../../../../public/upgrade/root/toast/notification.service';
import * as import12 from '@angular/forms/src/form_builder';
import * as import13 from '../../../../../../public/upgrade/root/form-modal/form-modal.service';
import * as import14 from '../../../../../../public/upgrade/feature/restrictions/restrictions.service';
import * as import15 from '@angular/core/src/linker/query_list';
import * as import16 from '../../../../../../public/upgrade/shared/sara-select/sara-select.component';
import * as import17 from '../../../shared/sara-select/sara-select.component.ngfactory';
import * as import18 from '../../../../../../public/upgrade/feature/restrictions/rental-length-settings/rental-length-settings.component';
import * as import19 from '../rental-length-settings/rental-length-settings.component.ngfactory';
import * as import20 from '../../../../../../public/upgrade/shared/eva-button/eva-button.component';
import * as import21 from '../../../shared/eva-button/eva-button.component.ngfactory';
import * as import22 from '@ngx-translate/core/src/translate.pipe';
import * as import23 from '@ngx-translate/core/src/translate.service';
export class Wrapper_ModalGeneralSettingsComponent {
  /*private*/ _eventHandler:Function;
  context:import0.ModalGeneralSettingsComponent;
  /*private*/ _changed:boolean;
  /*private*/ _changes:{[key: string]:any};
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  subscription0:any;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any) {
    this._changed = false;
    this._changes = {};
    this.context = new import0.ModalGeneralSettingsComponent(p0,p1,p2,p3,p4,p5);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_generalValues(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.generalValues = currValue;
      this._changes['generalValues'] = new import1.SimpleChange(this._expr_0,currValue);
      this._expr_0 = currValue;
    }
  }
  check_openModal(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.openModal = currValue;
      this._changes['openModal'] = new import1.SimpleChange(this._expr_1,currValue);
      this._expr_1 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) {
      if (changed) {
        this.context.ngOnChanges(this._changes);
        this._changes = {};
      }
      if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); }
    }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.updateGeneralSetting.subscribe(_eventHandler.bind(view,'updateGeneralSetting'))); }
  }
}
var renderType_ModalGeneralSettingsComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_ModalGeneralSettingsComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.ModalGeneralSettingsComponent>;
  _GAService_0_3:import6.GAService;
  _ModalGeneralSettingsComponent_0_4:Wrapper_ModalGeneralSettingsComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_ModalGeneralSettingsComponent_Host0,renderType_ModalGeneralSettingsComponent_Host,import7.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'modal-general-settings',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_ModalGeneralSettingsComponent0(this.viewUtils,this,0,this._el_0);
    this._GAService_0_3 = new import6.GAService();
    this._ModalGeneralSettingsComponent_0_4 = new Wrapper_ModalGeneralSettingsComponent(this.injectorGet(import10.ActivatedRoute,this.parentIndex),this.injectorGet(import11.NotificationService,this.parentIndex),this.injectorGet(import12.FormBuilder,this.parentIndex),this.injectorGet(import13.FormModalService,this.parentIndex),this.injectorGet(import14.RestrictionsService,this.parentIndex),this._GAService_0_3);
    this.compView_0.create(this._ModalGeneralSettingsComponent_0_4.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import9.ComponentRef_<any>(0,this,this._el_0,this._ModalGeneralSettingsComponent_0_4.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import6.GAService) && (0 === requestNodeIndex))) { return this._GAService_0_3; }
    if (((token === import0.ModalGeneralSettingsComponent) && (0 === requestNodeIndex))) { return this._ModalGeneralSettingsComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ModalGeneralSettingsComponent_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._ModalGeneralSettingsComponent_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const ModalGeneralSettingsComponentNgFactory:import9.ComponentFactory<import0.ModalGeneralSettingsComponent> = new import9.ComponentFactory<import0.ModalGeneralSettingsComponent>('modal-general-settings',View_ModalGeneralSettingsComponent_Host0,import0.ModalGeneralSettingsComponent);
const styles_ModalGeneralSettingsComponent:any[] = ([] as any[]);
var renderType_ModalGeneralSettingsComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_ModalGeneralSettingsComponent,{});
export class View_ModalGeneralSettingsComponent0 extends import2.AppView<import0.ModalGeneralSettingsComponent> {
  _viewQuery_modalGeneralForm_0:import15.QueryList<any>;
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  compView_12:import2.AppView<import16.SaraSelectComponent>;
  _SaraSelectComponent_12_3:import17.Wrapper_SaraSelectComponent;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  compView_18:import2.AppView<import18.RentalLengthSettingsComponent>;
  _RentalLengthSettingsComponent_18_3:import19.Wrapper_RentalLengthSettingsComponent;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _el_25:any;
  compView_25:import2.AppView<import20.EvaButtonComponent>;
  _EvaButtonComponent_25_3:import21.Wrapper_EvaButtonComponent;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  /*private*/ _expr_36:any;
  _pipe_translate_0:import22.TranslatePipe;
  /*private*/ _expr_38:any;
  _pipe_translate_1:import22.TranslatePipe;
  _map_40:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_ModalGeneralSettingsComponent0,renderType_ModalGeneralSettingsComponent,import7.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_36 = import1.UNINITIALIZED;
    this._expr_38 = import1.UNINITIALIZED;
    this._map_40 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        itemList: p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_modalGeneralForm_0 = new import15.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'h5',new import3.InlineArray2(2,'class','modal-title eva-3-h5'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._text_2 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,parentRenderNode,'h5',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'',(null as any));
    this._text_5 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','modal-border-bottom -eva-3-mt-lg -eva-3-mb-xlg'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n    ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pb-sm'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n        ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','col -lg-3 -md-3 -sm-12'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'sara-select',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_12 = new import17.View_SaraSelectComponent0(this.viewUtils,this,12,this._el_12);
    this._SaraSelectComponent_12_3 = new import17.Wrapper_SaraSelectComponent();
    this._text_13 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_12.create(this._SaraSelectComponent_12_3.context);
    this._text_14 = this.renderer.createText(this._el_10,'\n        ',(null as any));
    this._text_15 = this.renderer.createText(this._el_8,'\n    ',(null as any));
    this._text_16 = this.renderer.createText(this._el_6,'\n',(null as any));
    this._text_17 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,parentRenderNode,'rental-length-settings',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_18 = new import19.View_RentalLengthSettingsComponent0(this.viewUtils,this,18,this._el_18);
    this._RentalLengthSettingsComponent_18_3 = new import19.Wrapper_RentalLengthSettingsComponent(this.parentView.injectorGet(import14.RestrictionsService,this.parentIndex));
    this._text_19 = this.renderer.createText((null as any),'\n',(null as any));
    this.compView_18.create(this._RentalLengthSettingsComponent_18_3.context);
    this._text_20 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-xlg'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n    ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_21,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n        ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_23,'eva-button',new import3.InlineArray2(2,'class','submit-general-modal'),(null as any));
    this.compView_25 = new import21.View_EvaButtonComponent0(this.viewUtils,this,25,this._el_25);
    this._EvaButtonComponent_25_3 = new import21.Wrapper_EvaButtonComponent();
    this.compView_25.create(this._EvaButtonComponent_25_3.context);
    this._text_26 = this.renderer.createText(this._el_23,'\n    ',(null as any));
    this._text_27 = this.renderer.createText(this._el_21,'\n',(null as any));
    this._text_28 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._pipe_translate_0 = new import22.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import22.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_12,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_12));
    this._SaraSelectComponent_12_3.subscribe(this,this.eventHandler(this.handleEvent_12),true);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_18,new import3.InlineArray2(2,'rentalLengthChange',(null as any)),this.eventHandler(this.handleEvent_18));
    this._RentalLengthSettingsComponent_18_3.subscribe(this,this.eventHandler(this.handleEvent_18),true);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_25,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_25));
    this._viewQuery_modalGeneralForm_0.reset(([] as any[]));
    this.context.form = this._viewQuery_modalGeneralForm_0.first;
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._text_27,
      this._text_28
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import16.SaraSelectComponent) && ((12 <= requestNodeIndex) && (requestNodeIndex <= 13)))) { return this._SaraSelectComponent_12_3.context; }
    if (((token === import18.RentalLengthSettingsComponent) && ((18 <= requestNodeIndex) && (requestNodeIndex <= 19)))) { return this._RentalLengthSettingsComponent_18_3.context; }
    if (((token === import20.EvaButtonComponent) && (25 === requestNodeIndex))) { return this._EvaButtonComponent_25_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_12_0_0:any = this.context.errors['daysInAdvance'];
    this._SaraSelectComponent_12_3.check_error(currVal_12_0_0,throwOnChange,false);
    const currVal_12_0_1:any = 'defaultReleaseDays';
    this._SaraSelectComponent_12_3.check_name(currVal_12_0_1,throwOnChange,false);
    const currVal_12_0_2:any = this._map_40('restrictions.GENERAL_CONFIG.MODAL.selectDescription1',this.context.selectRelease);
    this._SaraSelectComponent_12_3.check_messages(currVal_12_0_2,throwOnChange,false);
    const currVal_12_0_3:any = false;
    this._SaraSelectComponent_12_3.check_required(currVal_12_0_3,throwOnChange,false);
    const currVal_12_0_4:any = this.context.modalValues.daysInAdvance;
    this._SaraSelectComponent_12_3.check_model(currVal_12_0_4,throwOnChange,false);
    this._SaraSelectComponent_12_3.ngDoCheck(this,this._el_12,throwOnChange);
    const currVal_18_0_0:any = this.context.modalValues.minRentalLength;
    this._RentalLengthSettingsComponent_18_3.check_min(currVal_18_0_0,throwOnChange,false);
    const currVal_18_0_1:any = this.context.modalValues.maxRentalLength;
    this._RentalLengthSettingsComponent_18_3.check_max(currVal_18_0_1,throwOnChange,false);
    const currVal_18_0_2:any = this.context.errors;
    this._RentalLengthSettingsComponent_18_3.check_errors(currVal_18_0_2,throwOnChange,false);
    this._RentalLengthSettingsComponent_18_3.ngDoCheck(this,this._el_18,throwOnChange);
    const currVal_25_0_0:any = this.context.saveButton;
    this._EvaButtonComponent_25_3.check_button(currVal_25_0_0,throwOnChange,false);
    this._EvaButtonComponent_25_3.ngDoCheck(this,this._el_25,throwOnChange);
    valUnwrapper.reset();
    const currVal_36:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_0.transform('restrictions.GENERAL_CONFIG.MODAL.subtitle1')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_36,currVal_36))) {
      this.renderer.setText(this._text_1,currVal_36);
      this._expr_36 = currVal_36;
    }
    valUnwrapper.reset();
    const currVal_38:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_1.transform('restrictions.GENERAL_CONFIG.MODAL.description1')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_38,currVal_38))) {
      this.renderer.setText(this._text_4,currVal_38);
      this._expr_38 = currVal_38;
    }
    this.compView_12.internalDetectChanges(throwOnChange);
    this.compView_18.internalDetectChanges(throwOnChange);
    this.compView_25.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_12.destroy();
    this.compView_18.destroy();
    this.compView_25.destroy();
    this._SaraSelectComponent_12_3.ngOnDestroy();
    this._RentalLengthSettingsComponent_18_3.ngOnDestroy();
    this._EvaButtonComponent_25_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  handleEvent_12(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.modalValues.daysInAdvance = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_18(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'rentalLengthChange')) {
      const pd_sub_0:any = ((<any>this.context.onRentalLengthChange($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_25(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.updateCallback()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/restrictions/modal-general-settings/modal-general-settings.component.ngfactory.ts